export const tooltips = {
  trackStockProduct: {
    rawMaterialBtn: `Esse botão serve para que o administrador possa ver
           todas as matérias primas, que são MP indiretas( que são as que não participam dos diretamente nos  produtos vendidos) 
           e matérias primas diretas MP diretas (produtos que participam diretamente da confecção dos produtos vendidos) incluindo
        os disponívies e indisponíveis, por isso nessa categoria temos linhas vermelhas,
         mostrando as matérias primas, indisponíveis (pintado de vermelho) e disponíveis (sem coloração)`,
    btnEdit: `Aqui você pode editar os valores de um produto que não estejam corretos
                deixando uma justificativa sobre as mudanças`,
    toggleBtn: `Esse botão alterna entre Excluir e Restaurar, dependendo da tela.
                Se está na tela de itens que podem ser excluídos porque estão disponíveis o 
                titulo do botão é Exluir e se estiver na tela de itens que já foram excluídos 
                tem o titulo de Reaturar, para que voltem a ficar disponíveis`,
    toggleBtnAbleAndDisable: `Esse botão alterna entre o itens que pertencem ao estoque mais não estão
      disponíveis no momento e os que estão disponíveis. Enfatizando que também nesse caso
      o título do botão alterna entre itens excluídos e itens habilitados`,
  },
  addDishesForm: {
    title: "Nome do prato que aparecerá no cardápio.",
    category: "Grupo onde o prato será exibido para o cliente.",
    comment: "Resumo dos ingredientes ou descrição rápida.",
    price: "Valor de venda do produto.",
    image: "Envie uma foto do seu prato direto do celular ou computador.",
    sideDishes: "Gerencie itens extras que podem ser adicionados ao prato.",
    carrossel: "Marque para destacar este prato no topo da página principal.",
  },
  priceBuilder: {
    price: "Preço final de venda para o cliente.",
    cost: "Quanto custa para você produzir este item (insumos + mão de obra).",
    percentage: "Margem de lucro desejada sobre o custo do produto.",
    calculate: "Calcula automaticamente o custo baseado nos ingredientes cadastrados.",
    send: "Salva as informações de preço e custo.",
  },
  customizePriceForm: {
    label: "Nome identificador do preço (ex: Pequeno, Grande, Combo).",
  },
  includeSideDishesForm: {
    select: "Selecione um ou mais acompanhamentos para oferecer com este prato.",
    limit: "Limite máximo de acompanhamentos que o cliente pode escolher.",
    add: "Confirma a seleção de acompanhamentos para este prato.",
  },
};
